import FieldsTranslation from "graphql/fields/FieldsTranslation";

export default `
	guid
    created_at
    payment_provider
    credits_amount
    amount
    price
    price_total
    status

    credit_bundle {
        guid
    }

    employee {
        guid
    }

    payment {
        guid
        external_redirect_url
        status
    }

    payments {
        guid
    }
`;
